import { ErrorMessage, FieldArray, Form, Formik } from 'formik';
import { ModalStatusType } from '../../../types/common';
import ModalComponent from '../../../components/modal/modal';
import ModalBodyComponent from '../../../components/modal/modalBodyComponent';
import InputText from '../../../components/input-text/inputText';
import ModalFooterComponent from '../../../components/modal/modalFooterComponent';
import { Label, UploadWrapper } from '../../../components/input-text/input.styled';
import ImageViewer from '../../../components/input-file/inputFileWithView';
import { useState } from 'react';
import CustomTextArea from '../../../components/text-area/textArea';
import FormSelect from '../../../components/dropdown/formSelect';
import { ActiveOptions } from '../../../constants/common';
import RichTextEditor from '../../../components/rich-text-editor';
import ImageViewerSingle from '../../../components/input-file/inputFileWithViewSingle';
import Heading from '../../../components/typography';
import { COLORS } from '../../../constants/style/color';
import { useWealthlaneAwardApi } from '../../../hooks';
import { SwitchContainer } from './planManagement.styled';

interface GrantDocumentTermAndConditionModelType {
  isModalOpen: boolean;
  closeModal: () => void;
  modalStatus: ModalStatusType;
  //   setModalStatus: (value: ModalStatusType) => void;
  initialData: {
    data: any;
    id: string;
  };
  rowData?: any;
  id?: string;
  modelName?: string;
  documentDto?: any;
  setDocumentDto: any;
  documentType?: string | number | null;
  setDocumentType: any;
  domId?: string;
}

const GrantDocumentTermAndConditionModel = ({
  isModalOpen,
  closeModal,
  modalStatus,
  initialData,
  //   setModalStatus,
  rowData,
  id,
  modelName,
  documentDto,
  setDocumentDto,
  documentType,
  setDocumentType,
  domId
}: GrantDocumentTermAndConditionModelType): JSX.Element => {
  const [removedId, setRemovedId] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [toggle, setToggle] = useState<boolean>(false);
  const { handleRequest } = useWealthlaneAwardApi();
  const [checkNameError, setCheckNameError] = useState();

  const handleImageOpen = (name: string): void => {
    setLoading(true);

    setLoading(false);
  };
  const handleSubmit = (
    values: any,
    documentType?: string | number | null,
    documentDto?: any
  ): void => {
    setLoading(true);
    setDocumentDto([
      ...documentDto,
      {
        ...values,
        document: values?.document?.base64String,
        grantDocumentType: documentType,
        fileExtension: '.' + values?.document?.[0]?.name?.split('.')?.reverse()[0],
      },
    ]);

    closeModal();
    setLoading(false);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{ name: '' }}
      //   validationSchema={PERFORMANCE_RULE_VALIDATION}
      onSubmit={(values) => {
        // handleSubmit(values);
      }}>
      {({
        touched,
        handleChange,
        errors,
        setFieldValue,
        setFieldTouched,
        values,
        setTouched,
        setFieldError,
      }: any) => {
        return (
          <>
            <ModalComponent
              show={isModalOpen}
              closeModal={closeModal}
              loading={false}
              size='lg'
              //   valueEdited={_.isEqual(
              //     values,
              //     modalStatus !== 'Add' ? initialValue : initialData?.data
              //   )}
              customAlertMessage={'Your changes will not be saved. Are you sure you want to close?'}
              title={`Update ${modelName}`}
              id={domId}
              children={
                <Form id="grantDocumentTermAndConditionForm">
                  <ModalBodyComponent id="grantDocumentTermAndConditionModalBody">
                    <>
                      {/* <Heading variant='h5' title='Terms & Condition' color={COLORS.Gray600} /> */}
                      <div className='grid sm:grid-cols-12 gap-x-8 mt-5' id="agreementStatementSection">
                        <InputText
                          type='text'
                          label='Agreement Statement '
                          className='col-span-9'
                          name='termsAndConditionsAgreementStatement'
                          onChange={handleChange}
                          errors={errors}
                          touched={touched}
                          inputType={modalStatus}
                          disabled={modalStatus === 'View'}
                          required
                          id="agreementStatementInput"
                        />
                        <div className='sm:col-span-3' id="statusSection">
                          <FormSelect
                            name={'isActive'}
                            label='Status'
                            viewName='isActive'
                            containerClassName='formGroup'
                            setFieldValue={setFieldValue}
                            onChange={handleChange}
                            placeholder={'Select'}
                            options={ActiveOptions}
                            touched={touched}
                            errors={errors}
                            values={values}
                            inputType={modalStatus}
                            disabled={modalStatus === 'View'}
                            required
                            id="statusSelect"
                          />
                        </div>
                      </div>
                      <SwitchContainer id="emailToggleSection">
                        <div className='flex gap-2'>
                          <label className='switch'>
                            <input
                              type='checkbox'
                              onChange={(e: any) => {
                                setToggle(e.target.checked);

                                // CompanyNotificationConfig(e.target.checked);
                              }}
                              checked={toggle}
                              id="emailToggleCheckbox"
                            />
                            <span className='slider round'></span>
                          </label>
                          <Heading title={'Enable/Disable Email'} variant='body' id="emailToggleLabel" />
                        </div>
                      </SwitchContainer>

                      {toggle ? (
                        <div className='grid grid-cols-12' id="emailContentSection">
                          {modalStatus !== 'View' ? (
                            <div className='col-span-12'>
                              <>
                                <RichTextEditor
                                  name='termsAndConditionsDocumentContent'
                                  setFieldValue={setFieldValue}
                                  value={
                                    (values?.termsAndConditionsDocumentContent as boolean)
                                      ? values?.termsAndConditionsDocumentContent
                                      : ''
                                  }
                                  error={errors?.termsAndConditionsDocumentContent}
                                  touched={touched?.termsAndConditionsDocument}
                                  id="termsAndConditionsDocumentContentEditor"
                                />
                              </>
                              <ErrorMessage
                                name='termsAndConditionsDocumentContent'
                                component='div'
                                className='error-message'
                              />
                            </div>
                          ) : (
                            <div className='col-span-12'>
                              <Label>Description</Label>

                              <div
                                dangerouslySetInnerHTML={{
                                  __html: values?.termsAndConditionsDocumentContent,
                                }}
                                className={`border p-2 text-2xl rounded-lg bg-[#F3F3F3] descriptionOutput`}
                                id="termsAndConditionsDocumentContentDisplay"
                              />
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className='gap-3 justify-between mt-8' id="documentUploadSection">
                          <div>
                            <Label htmlFor={'document'} className={'pb-1'}>
                              {modalStatus === 'View' ? '' : 'Upload Terms & Condition'} Document
                            </Label>
                            {/* {modalStatus === 'View' &&
                          (values.termsAndConditionsDocumentName[0]?.file.name === undefined ||
                            values.termsAndConditionsDocumentName[0]?.file.name === null) ? (
                            <UploadWrapper className='flex justify-center'>
                              <Heading
                                variant='h6'
                                title='No document to show'
                                color={COLORS.SpanishGray}
                                className='flex justify-center'
                              />
                            </UploadWrapper>
                          ) : ( */}
                            <div id="documentUploadContainer">
                              <ImageViewerSingle
                                setFieldValue={setFieldValue}
                                setFieldTouched={setFieldTouched}
                                modalStatus={modalStatus}
                                values={values}
                                errors={errors}
                                touched={touched}
                                errorValue={errors?.document}
                                touchedValue={touched?.document}
                                name='document'
                                listingName='documentNameList'
                                // accept='.pdf, .jpg, .jpeg, .png, .docx, .doc'
                                loading={loading}
                                removedId={removedId}
                                handleImageOpen={handleImageOpen}
                                setRemovedId={setRemovedId}
                                uploadLimit={1}
                                isSingleFile={true}
                                setFieldError={setFieldError}
                                isBase64={true}
                              />
                            </div>
                            {/* )} */}
                          </div>
                        </div>
                      )}
                    </>
                  </ModalBodyComponent>
                  <ModalFooterComponent
                    modalStatus={modalStatus}
                    loading={false}
                    isEditShow={rowData?.approvalStatus !== 'Rejected' ? true : false}
                    // isButton={true}
                    buttonTitle='Add'
                    // isTmc={modalStatus === 'View' && id ? true : false}
                    onCloseModal={() => {
                      closeModal();
                    }}
                    // valueChanged={_.isEqual(values, initialValue || initialData?.data)}
                    // onEditModal={() => {
                    //   setModalStatus('Edit');
                    // }}
                    customAlertMessage={
                      'Your changes will not be saved. Are you sure you want to close?'
                    }
                    id="grantDocumentTermAndConditionModalFooter"
                  />
                </Form>
              }
            />
          </>
        );
      }}
    </Formik>
  );
};

export default GrantDocumentTermAndConditionModel;
